// extracted by mini-css-extract-plugin
export default {"highlight":"styles_highlight__vR5C0"};